import dynamic from 'next/dynamic';
import Quill from 'quill';
import {
    forwardRef,
    memo,
    useCallback,
    useEffect,
    useImperativeHandle,
    useRef,
} from 'react';
import { QuillEditorProps, QuillEditorRefs } from './quill-editor';

const QuillEditor = dynamic(() => import('./quill-editor'), { ssr: false });

/**cần có cái wrapper này để sử dụng ref với editor, truyền trực tiếp qua dynamic không được */
const QuillEditorWrapper = forwardRef<QuillEditorRefs, QuillEditorProps>(
    ({ controlled = false, ...props }, ref) => {
        const quillInstanceRef = useRef<Quill>();

        const getValue = useCallback(() => {
            return quillInstanceRef.current?.root.innerHTML || '';
        }, []);
        const setValue = useCallback((str: string) => {
            if (quillInstanceRef.current?.root) {
                quillInstanceRef.current.root.innerHTML = str;

                // auto focus in end
                const range = document.createRange();
                const selection = window.getSelection();
                range.selectNodeContents(quillInstanceRef.current.root);
                range.collapse(false);
                selection?.removeAllRanges();
                selection?.addRange(range);
            }
        }, []);

        useEffect(() => {
            if (controlled) {
                setValue(props.value || '');
            }
        }, [controlled, props.value, setValue]);

        useImperativeHandle(ref, () => {
            return {
                getValue,
                setValue,
            };
        }, [getValue, setValue]);

        return <QuillEditor {...props} quillInstanceRef={quillInstanceRef} />;
    }
);

QuillEditorWrapper.displayName = 'QuillEditorWrapper';
export default memo(QuillEditorWrapper);
